//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

const styles = {
    card: {
        maxWidth: 400,
        height: 350
    },
    media: {
        // ⚠️ object-fit is not supported by IE 11.
        objectFit: 'cover',
    },
};


//'url(' + require('../../images/IMG_1.JPG')
class MoneyCard extends React.Component {

            constructor(props) {
                super(props);

            }

            render() {
            const {classes} = this.props;
            return (
                < Card
            className = {classes.card}  elevation={20}>
                < CardActionArea >
                < CardMedia
            component = "img"
            alt = "Saving Money"
            className = {classes.media}
            height = "140"
            image = { '/static/images/time0.png'}
            title = "Save Money"
                / >
                < CardContent >
                < Typography
              gutterBottom
            variant = "h5"
            component = "h2" >
                Time
                < /Typography>
                < Typography
            component = "p" >
              Time to get your vehicle back, means time away from your business and family. No one can put any monetary value on time. Time is your most precious asset.
            < /Typography>
            < /CardContent>
            < /CardActionArea>
              {/*}
            < CardActions >
            < Button
            size = "small"
            color = "primary" >
                Share
                < /Button>
                < Button
                size = "small"
                color = "primary" href="#aboutplatewiz" >
                Learn
            More
            < /Button>
            < /CardActions> */}
            < /Card>
        )
            ;
        }//end of render
}//End of class

MoneyCard.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MoneyCard);